import request from '@/utils/request'

export function fetchList(pagenum, rownum) {

    return request({
        url: '/sap/bc/zhr/zhr',
        method: 'get',
        params: {
            method: "HR-NOTICE",
            pagenum: pagenum,
            rownum:rownum
        }
    })
}

export function getHrNoticeByGuid(guid) {
    return request({
        url: '/sap/bc/zhr/zhr',
        method: 'get',
        params: {
            method: "HR-NOTICE",
            SYSTEM:'ZHAOPIN',
            objid: guid
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/announcement.js